export const REPORT_TYPE_SET = {
  "volume": "버즈량",
  "sentiment": "감성 분석",
  "source": "영향 채널",
  "relation": "워드 클라우드",
  "category": "카테고리 분석",
  "positioningmap": "포지셔닝 맵",
  "buzzlist": "버즈 리스트",
  "emotion": "이모션",
  "channel_buzzlist": "채널 버즈리스트"
}

export const REPORT_OPTIONS_SET = {
  "monthly": "월간",
  "weekly": "주간",
  "daily": "일간",
  //  "hourly": "시간",
  "numeric": "수치",
  "percentage": "백분율",
  "noun": "명사만",
  "verb": "동사만",
  "all": "전체"
}
